import { render, staticRenderFns } from "./ShopOrders.vue?vue&type=template&id=6462d8fc&scoped=true&"
import script from "./ShopOrders.vue?vue&type=script&lang=js&"
export * from "./ShopOrders.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrders.vue?vue&type=style&index=0&id=6462d8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462d8fc",
  null
  
)

export default component.exports